import { canExploreSchoolAccess } from "../features/help/SchoolAccessDialog";
import { create } from "zustand";
import { useAuthenticationStore } from "./auth";
import { canOpenQuickStart, helpOwner } from "../features/help/contextualHelp";

import { canOpenIntroduction } from "../features/help/signupPurpose";

export const useHelpStore = create((set) => ({
  panel: null,
  owner: null,
  openSchoolAccess: () => {
    const { user } = useAuthenticationStore.getState();
    if (canExploreSchoolAccess(user))
      set({ panel: "school-access", owner: helpOwner(user) });
  },
  openHelp: () => {
    const { user } = useAuthenticationStore.getState();
    if (user?.isLoggedIn) set({ panel: "help", owner: helpOwner(user) });
  },
  openIntroduction: () => {
    const { user, markIntroductionSeen } = useAuthenticationStore.getState();
    if (canOpenIntroduction(user)) {
      markIntroductionSeen(user.signInSession, user.info.id);
      set({ panel: "introduction", owner: helpOwner(user) });
    }
  },
  openQuickStart: () => {
    const { user } = useAuthenticationStore.getState();
    if (canOpenQuickStart(user))
      set({ panel: "quick-start", owner: helpOwner(user) });
  },
  close: () => set({ panel: null, owner: null }),
}));
